/*售后*/
/* keepAlive:该页面是否缓存
backHome:回到首页按钮是否显示
*/
export default [
  {
    path: "saleService/application",
    name: "saleServiceApplication",
    meta: {
      title: "申请退款",
      keepAlive: false,
    },
    component: () => import("@/views/saleService/application.vue"),
  },
  {
    path: "saleService/refundDetails",
    name: "saleServiceRefundDetails",
    meta: {
      title: "退款详情",
      keepAlive: false,
    },
    component: () => import("@/views/saleService/refundDetails.vue"),
  },
];
